import React from 'react';

const VerifyCheckoutDetails = ({ onNext }) => {
  // Get data from local storage
  const primaryGuest = JSON.parse(localStorage.getItem('primaryGuest'));
  const reservationDetails = JSON.parse(localStorage.getItem('reservationDetails'));
  const checkoutData = JSON.parse(localStorage.getItem('checkoutData')) || {};
  const orderId = localStorage.getItem('orderId');

  const guestDetails = {
    guestName: `${primaryGuest?.firstname || ''} ${primaryGuest?.lastname || ''}`,
    guestPhone: primaryGuest?.phonenumber || '',
    guestEmail: primaryGuest?.emailid || '',
  };

  const bookingDetails = {
    checkInDate: reservationDetails?.checkin_date || '',
    checkOutDate: reservationDetails?.checkout_date || '',
    roomType: reservationDetails?.room_type || '',
    roomNumber: reservationDetails?.room_number || '',
    lengthOfStay: reservationDetails?.length_of_stay || 0,
    numberOfGuests: reservationDetails?.number_of_guests || 0,
    reservationNumber: orderId || '', // Changed from bookingId to orderId
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  // Get additional guests from checkoutData
  const additionalGuests = checkoutData?.other_guests || [];

  return (
    <div className="space-y-6">
      {/* Guest Details */}
      <div>
        <h2 className="text-xl font-bold mb-1 text-gray-900">Verify Details</h2>
        <p className="text-gray-600 text-sm mb-6 mt-">Please verify the details of your stay</p>
      </div>
      <div>
        <h3 className="text-base font-medium mb-3 flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-2"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
              clipRule="evenodd"
            />
          </svg>
          Guest Details
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
          {[
            {
              label: 'Full Name',
              value: guestDetails.guestName
                .split(' ')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                .join(' '),
              icon: 'user',
            },

            { label: 'Email', value: guestDetails.guestEmail, icon: 'mail' },
            {
              label: ' Mobile number',
              value: guestDetails.guestPhone,
              icon: 'phone',
            },

            {
              label: 'Room Type',
              value: bookingDetails.roomType,
              icon: 'home',
            },
            {
              label: 'Reservation Number',
              value: bookingDetails.reservationNumber,
              icon: 'identification',
            },
            {
              label: 'No of Guests',
              value: bookingDetails.numberOfGuests,
              icon: 'users',
            },
          ].map(({ label, value, icon }) => (
            <div key={label} className="bg-gray-50 p-3 rounded border border-gray-100">
              <div className="flex items-center mb-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3 w-3 mr-1"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={
                      icon === 'user'
                        ? 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
                        : icon === 'mail'
                          ? 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'
                          : icon === 'phone'
                            ? 'M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z'
                            : icon === 'identification'
                              ? 'M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2'
                              : icon === 'users'
                                ? 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z'
                                : 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'
                    }
                  />
                </svg>
                <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                  {label}
                </span>
              </div>
              <p className="text-sm font-medium text-gray-800">{value || 'N/A'}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Additional Guest Details */}
      {additionalGuests.length > 0 && (
        <div>
          <h3 className="text-base font-medium mb-3 flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
                clipRule="evenodd"
              />
            </svg>
            Additional Guest Details
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
            {additionalGuests.map((guest, index) => (
              <div key={index} className="bg-gray-50 p-3 rounded border border-gray-100">
                <div className="flex items-center mb-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-3 w-3 mr-1"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                    />
                  </svg>
                  <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Guest {index + 1}
                  </span>
                </div>
                <p className="text-sm text-transform: capitalize font-medium text-gray-800 mb-1">
                  {guest.firstname} {guest.lastname}
                </p>
                {/* {guest.emailid && (
                  <p className="text-xs text-gray-600">{guest.emailid}</p>
                )} */}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Stay Information */}
      <div>
        <h3 className="text-base font-medium mb-3 flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          Stay Information
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
          <div className="bg-gray-50 p-3 rounded border border-gray-200">
            <div className="flex justify-between items-center mb-1">
              <span className="text-xs font-medium text-gray-600 uppercase tracking-wider">
                Check-In
              </span>
              <span className="text-xs px-1.5 py-0.5 bg-gray-200 text-gray-800 rounded-full">
                Completed
              </span>
            </div>
            <p className="font-bold text-gray-900 text-base">
              {formatDate(bookingDetails.checkInDate)}
            </p>
          </div>

          <div className="bg-gray-50 p-3 rounded border border-gray-200">
            <div className="text-xs font-medium text-gray-600 uppercase tracking-wider mb-1">
              Check-Out
            </div>
            <p className="font-bold text-gray-900 text-base">
              {formatDate(bookingDetails.checkOutDate)}
            </p>
            <p className="text-xs text-gray-600">Current time: {new Date().toLocaleTimeString()}</p>
          </div>

          <div className="bg-gray-50 p-3 rounded border border-gray-200">
            <div className="text-xs font-medium text-gray-600 uppercase tracking-wider mb-1">
              No of nights
            </div>
            <p className="font-bold text-gray-900 text-base">
              {bookingDetails.lengthOfStay} night
              {bookingDetails.lengthOfStay !== 1 ? 's' : ''}
            </p>
          </div>

          <div className="bg-gray-50 p-3 rounded border border-gray-200">
            <div className="text-xs font-medium text-gray-600 uppercase tracking-wider mb-1">
              Room Number
            </div>
            <p className="font-bold text-gray-900 text-base">
              {bookingDetails.roomNumber || 'N/A'}
            </p>
          </div>
        </div>
      </div>

      {/* Action Button */}
      <div className="pt-4 border-t border-gray-200 flex justify-end">
        <button
          onClick={onNext}
          className="w-full sm:w-1/4 px-4 py-2.5 bg-black text-white rounded font-medium hover:bg-gray-800 transition duration-150 flex items-center justify-center gap-2"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default VerifyCheckoutDetails;

// import React from "react";

// const VerifyCheckoutDetails = ({ onNext }) => {
//   // Get data from local storage
//   const primaryGuest = JSON.parse(localStorage.getItem("primaryGuest"));
//   const reservationDetails = JSON.parse(
//     localStorage.getItem("reservationDetails")
//   );
//   const checkoutData = JSON.parse(localStorage.getItem("checkoutData")) || {};
//   const orderId = localStorage.getItem("orderId");

//   const guestDetails = {
//     guestName: `${primaryGuest?.firstname || ""} ${
//       primaryGuest?.lastname || ""
//     }`,
//     guestPhone: primaryGuest?.phonenumber || "",
//     guestEmail: primaryGuest?.emailid || "",
//   };

//   const bookingDetails = {
//     checkInDate: reservationDetails?.checkin_date || "",
//     checkOutDate: reservationDetails?.checkout_date || "",
//     roomType: reservationDetails?.room_type || "",
//     roomNumber: reservationDetails?.room_number || "",
//     lengthOfStay: reservationDetails?.length_of_stay || 0,
//     numberOfGuests: reservationDetails?.number_of_guests || 0,
//     reservationNumber: orderId || "", // Changed from bookingId to orderId
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const options = { year: "numeric", month: "short", day: "numeric" };
//     return new Date(dateString).toLocaleDateString(undefined, options);
//   };

//   return (
//     <div className="space-y-6">
//       {/* Guest Details */}
//       <div>
//         <h2 className="text-xl font-bold mb-1 text-gray-900">Verify Details</h2>
//         <p className="text-gray-600 text-sm mb-6 mt-">
//           Please verify the details of your stay
//         </p>
//       </div>
//       <div>
//         <h3 className="text-base font-medium mb-3 flex items-center">
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-4 w-4 mr-2"
//             viewBox="0 0 20 20"
//             fill="currentColor"
//           >
//             <path
//               fillRule="evenodd"
//               d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
//               clipRule="evenodd"
//             />
//           </svg>
//           Guest Details
//         </h3>
//         <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
//           {[
//             {
//               label: "Full Name",
//               value: guestDetails.guestName
//                 .split(" ")
//                 .map(
//                   (word) =>
//                     word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
//                 )
//                 .join(" "),
//               icon: "user",
//             },

//             { label: "Email", value: guestDetails.guestEmail, icon: "mail" },
//             {
//               label: " Mobile number",
//               value: guestDetails.guestPhone,
//               icon: "phone",
//             },

//             {
//               label: "Room Type",
//               value: bookingDetails.roomType,
//               icon: "home",
//             },
//             {
//               label: "Reservation Number",
//               value: bookingDetails.reservationNumber, // Updated to use reservationNumber
//               icon: "identification",
//             },
//             {
//               label: "No of Guests",
//               value: bookingDetails.numberOfGuests,
//               icon: "users",
//             },
//           ].map(({ label, value, icon }) => (
//             <div
//               key={label}
//               className="bg-gray-50 p-3 rounded border border-gray-100"
//             >
//               <div className="flex items-center mb-1">
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   className="h-3 w-3 mr-1"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d={
//                       icon === "user"
//                         ? "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
//                         : icon === "mail"
//                         ? "M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
//                         : icon === "phone"
//                         ? "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
//                         : icon === "identification"
//                         ? "M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2"
//                         : icon === "users"
//                         ? "M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
//                         : "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
//                     }
//                   />
//                 </svg>
//                 <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">
//                   {label}
//                 </span>
//               </div>
//               <p className="text-sm font-medium text-gray-800">
//                 {value || "N/A"}
//               </p>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Stay Information */}
//       <div>
//         <h3 className="text-base font-medium mb-3 flex items-center">
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="h-4 w-4 mr-2"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
//             />
//           </svg>
//           Stay Information
//         </h3>
//         <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
//           <div className="bg-gray-50 p-3 rounded border border-gray-200">
//             <div className="flex justify-between items-center mb-1">
//               <span className="text-xs font-medium text-gray-600 uppercase tracking-wider">
//                 Check-In
//               </span>
//               <span className="text-xs px-1.5 py-0.5 bg-gray-200 text-gray-800 rounded-full">
//                 Completed
//               </span>
//             </div>
//             <p className="font-bold text-gray-900 text-base">
//               {formatDate(bookingDetails.checkInDate)}
//             </p>
//           </div>

//           <div className="bg-gray-50 p-3 rounded border border-gray-200">
//             <div className="text-xs font-medium text-gray-600 uppercase tracking-wider mb-1">
//               Check-Out
//             </div>
//             <p className="font-bold text-gray-900 text-base">
//               {formatDate(bookingDetails.checkOutDate)}
//             </p>
//             <p className="text-xs text-gray-600">
//               Current time: {new Date().toLocaleTimeString()}
//             </p>
//           </div>

//           <div className="bg-gray-50 p-3 rounded border border-gray-200">
//             <div className="text-xs font-medium text-gray-600 uppercase tracking-wider mb-1">
//               No of nights
//             </div>
//             <p className="font-bold text-gray-900 text-base">
//               {bookingDetails.lengthOfStay} night
//               {bookingDetails.lengthOfStay !== 1 ? "s" : ""}
//             </p>
//           </div>

//           <div className="bg-gray-50 p-3 rounded border border-gray-200">
//             <div className="text-xs font-medium text-gray-600 uppercase tracking-wider mb-1">
//               Room Number
//             </div>
//             <p className="font-bold text-gray-900 text-base">
//               {bookingDetails.roomNumber || "N/A"}
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* Early Checkout Notice */}

//       {/* Action Button */}
//       <div className="pt-4 border-t border-gray-200 flex justify-end">
//         <button
//           onClick={onNext}
//           className="w-full sm:w-1/4 px-4 py-2.5 bg-black text-white rounded font-medium hover:bg-gray-800 transition duration-150 flex items-center justify-center gap-2"
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default VerifyCheckoutDetails;
